
import { mapActions, mapState } from "vuex";
import commonUserAvatar from "../common/common-user-avatar.vue";

export default {
  components: { commonUserAvatar },
  data() {
    return {
      selectedItem: 1,
      items: [
        { text: "Real-Time", icon: "mdi-clock" },
        { text: "Audience", icon: "mdi-account" },
        { text: "Conversions", icon: "mdi-flag" }
      ]
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("restaurant", ["businessDetails", "locationDetails"])
  },
  methods: {
    ...mapActions("restaurant", ["getRestaurantChannels"]),
    ...mapActions("auth", ["logout"]),
    switchRestaurant(id) {
      this.$ls.set("selected-restaurant-id", id);
      window.location.reload();
      // this.$nuxt.$emit("switch-restaurant");
    },
    navigateToCreateRestaurantPage() {
      this.$router.push({
        name: "restaurant-create-restaurant",
        params: {
          hasBackButton: true
        }
      });
    }
  }
};
